import { ColorPickerProps } from '.';

// This object should contain a mock value for each required prop of this component
export const requiredProps: ColorPickerProps = {
  value: '#000',
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
    } as ColorPickerProps,
  },
];

export const testkitTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      onChange: () => {},
      onCancel: () => {},
      onConfirm: () => {},
    } as ColorPickerProps,
  },
];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
